"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TickList;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TickList = require("./TickList.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TickList(_ref) {
  var items = _ref.items;
  return _react.default.createElement("ul", {
    className: (0, _TickList.mTickList)().toString()
  }, items.map(function (element, key) {
    return _react.default.createElement("li", {
      key: key
    }, element);
  }));
}

TickList.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.string)
};
TickList.defaultProps = {
  items: []
};